import axios from 'axios'

// axios.defaults.baseURL = 'http://localhost:8080'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 响应拦截器
axios.interceptors.response.use(function (response) {
    let data = response.data;
    if(data!=""){
      if (data.success || data.code === 10000 || response.config.url.indexOf('/get/isPay/')>0) {
        return response.data
      } else {
        toast.text(data.msg, 'top');
      }
    }else{
      return
    }
}, function (error) {
    let code = error.response.status
    let msg = error.response.data.message
    toast.text(msg, 'top')
})



export default axios;



// WEBPACK FOOTER //
// ./src/api/axios.js